import { Button, Checkbox, FormGroup, Box, Paper, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PasswordGuide from './PasswordGuide';
import CustomFormControl from './CustomFormControl';
const styledForm = {
    bgcolor: '#fbfaff',
    m: 2,
    p: 4,
};

const CommonForm = (props) => {
    const { validator, inputOneData, inputTwoData, customStyle, passwordConditions } = props;
    const navigate = useNavigate();

    return (
        <FormGroup>
            <Paper sx={{ ...styledForm }} className={customStyle}>
                <Stack textAlign='start' spacing={2.5}>
                    <Typography variant='h4' sx={{ fontWeight: 600 }}>
                        {props?.formHeading}
                    </Typography>
                    <Typography
                        variant='body1'
                        sx={{ marginBottom: '1rem !important' }}
                        color='#535252'>
                        {props?.formSubHeading}
                    </Typography>
                    <CustomFormControl fieldProps={inputOneData} errorMsg={validator?.inputOne} />

                    <Typography variant='body2' color='red'>
                        {validator?.inputOne}
                    </Typography>
                    {inputTwoData && (
                        <CustomFormControl
                            fieldProps={inputTwoData}
                            errorMsg={validator?.inputTwo}
                        />
                    )}
                    {validator?.inputTwo && (
                        <Box>
                            <Typography variant='body2' color='red'>
                                {validator?.inputTwo}
                            </Typography>
                        </Box>
                    )}

                    {props?.checkBoxData && (
                        <Box sx={{ ml: -1, marginTop: '0.4rem !important' }}>
                            <Checkbox
                                size='small'
                                checked={props?.checkBoxVal}
                                onClick={props?.onCheckboxClick}
                            />
                            <span style={{ fontSize: '0.9rem' }}>{props?.checkBoxData}</span>
                        </Box>
                    )}
                    {passwordConditions && (
                        <Box>
                            <PasswordGuide passwordConditions={passwordConditions} />
                        </Box>
                    )}

                    <Button
                        variant='contained'
                        color='primary'
                        size='large'
                        onClick={props?.onClick}
                    >
                        {props?.buttonName}
                    </Button>
                    {props?.id === 1 && (
                        <Button
                            color='primary'
                            variant='text'
                            disableFocusRipple
                            disableRipple
                            sx={{fontSize:'0.9rem'}}
                            disableElevation
                            onClick={() => navigate('/account-recovery')}
                        >
                            Forgot Password?
                        </Button>
                    )}
                </Stack>
            </Paper>
        </FormGroup>
    );
};

export default CommonForm;
